module.exports = __webpack_public_path__ + "static/media/41_tn.30666b96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/41_tn.jpg
// module id = 350
// module chunks = 0